var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMntl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3344_32683)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "url(#paint0_radial_3344_32683)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M20.5716 7.99993V15.9999C20.5723 16.4277 20.413 16.8403 20.125 17.1566C19.837 17.473 19.4411 17.6702 19.0151 17.7095C18.5891 17.749 18.1639 17.6276 17.8227 17.3694C17.4816 17.1112 17.2494 16.7349 17.1716 16.3142C17.1534 16.2104 17.1438 16.1053 17.1431 15.9999V14.6971C17.14 14.3352 17.0225 13.9836 16.8074 13.6926C16.5923 13.4015 16.2907 13.186 15.9456 13.077C15.6006 12.9679 15.2299 12.9708 14.8866 13.0852C14.5432 13.1997 14.245 13.4199 14.0345 13.7142L13.1431 14.9656L11.7088 16.9771C11.4352 17.3249 11.0378 17.5535 10.5995 17.615C10.1613 17.6765 9.71633 17.5662 9.35759 17.3071C8.99884 17.048 8.75421 16.6602 8.67479 16.2249C8.59541 15.7896 8.68742 15.3404 8.93164 14.9714L14.6459 6.97136C14.8038 6.76073 15.0082 6.58936 15.243 6.47044C15.4779 6.35153 15.737 6.28827 16.0002 6.28564H18.8574C19.312 6.28564 19.748 6.46627 20.0695 6.78776C20.391 7.10924 20.5716 7.5453 20.5716 7.99993Z",
    fill: "#FFFDFA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M15.1429 17.1428C15.9319 17.1428 16.5715 16.5032 16.5715 15.7142C16.5715 14.9252 15.9319 14.2856 15.1429 14.2856C14.354 14.2856 13.7144 14.9252 13.7144 15.7142C13.7144 16.5032 14.354 17.1428 15.1429 17.1428Z",
    fill: "#0D0A03"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M10.8573 6.28564H5.143C4.68834 6.28564 4.25231 6.46627 3.93081 6.78776C3.60932 7.10924 3.42871 7.5453 3.42871 7.99993V15.9999C3.42936 16.3628 3.54512 16.716 3.75933 17.0089C3.97354 17.3018 4.27515 17.5191 4.62074 17.6296C4.96633 17.7402 5.33808 17.7382 5.68249 17.624C6.02688 17.5099 6.3262 17.2893 6.53728 16.9942L12.2516 8.99422C12.434 8.73799 12.5424 8.43644 12.565 8.12267C12.5875 7.8089 12.5232 7.49502 12.3793 7.2153C12.2353 6.93564 12.0172 6.70096 11.7487 6.53696C11.4803 6.37302 11.1719 6.28604 10.8573 6.28564ZM6.28585 10.2856C6.0598 10.2856 5.83888 10.2186 5.65092 10.093C5.46297 9.96747 5.31649 9.78896 5.22999 9.58016C5.14349 9.3713 5.12086 9.14153 5.16496 8.91982C5.20905 8.69816 5.3179 8.4945 5.47773 8.33467C5.63756 8.17484 5.84123 8.06599 6.06288 8.02187C6.2846 7.97782 6.51437 8.00044 6.72323 8.0869C6.93203 8.17342 7.11054 8.31993 7.23608 8.50787C7.36168 8.69582 7.42871 8.91673 7.42871 9.14279C7.42871 9.44587 7.30831 9.73656 7.09397 9.9509C6.87963 10.1652 6.58894 10.2856 6.28585 10.2856Z",
    fill: "#0D0A03"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3344_32683",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12 12) scale(12)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.473958,
    stopColor: "#FFC640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2AF13"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3344_32683"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMntl);
export default __webpack_public_path__ + "static/media/mntl.dd30d33fef61b6f9d5a70473d7ba0c51.svg";
export { ForwardRef as ReactComponent };